import React from 'react';
import { motion } from 'framer-motion';
import { Check, Shield } from 'lucide-react';
export function PricingCTA() {
  return <section id="pricing" className="py-24 px-6 bg-[#1C1C2E] relative overflow-hidden" data-id="element-159">
      {/* Background Glow */}
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-full h-[600px] bg-[radial-gradient(circle_at_bottom,rgba(212,165,116,0.15)_0%,transparent_70%)] pointer-events-none" data-id="element-160" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-161">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-[#14142B] rounded-3xl p-8 md:p-12 border border-[#D4A574]/30 shadow-[0_0_50px_-10px_rgba(212,165,116,0.15)] text-center" data-id="element-162">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-white mb-4" data-id="element-163">
            Empezá esta misma noche
          </h2>
          <p className="text-lg text-[#F5F0E8]/80 mb-8 max-w-xl mx-auto" data-id="element-164">
            Si hoy la noche te está ganando, no esperes a "tener más paciencia".
            La paciencia no se fabrica a las 23:30.
          </p>

          <div className="flex flex-col items-center mb-10" data-id="element-165">
            <div className="inline-block bg-[#D4A574]/20 text-[#D4A574] font-bold text-sm uppercase tracking-widest px-4 py-1.5 rounded-full mb-4" data-id="element-166">
              🔥 Oferta por tiempo limitado
            </div>
            <div className="flex items-baseline gap-3" data-id="element-167">
              <span className="text-2xl md:text-3xl text-[#F5F0E8]/40 line-through font-medium" data-id="element-168">
                USD 17
              </span>
              <span className="text-5xl md:text-6xl font-bold text-white" data-id="element-169">
                USD 6.39
              </span>
            </div>
            <div className="mt-3 inline-block bg-[#5A8A7A]/20 text-[#5A8A7A] font-semibold text-sm px-3 py-1 rounded-full" data-id="element-170">
              Ahorrás un 62%
            </div>
            <p className="text-[#F5F0E8]/60 mt-3 text-sm" data-id="element-171">
              Pago único • Acceso inmediato • Descarga digital
            </p>
          </div>

          <motion.a href="https://vidaclave.online/cart/52657963008367:1" target="_blank" rel="noopener noreferrer" whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} className="inline-block w-full md:w-auto bg-[#D4A574] hover:bg-[#C39363] text-[#1C1C2E] font-bold text-xl px-12 py-5 rounded-full shadow-[0_0_30px_rgba(212,165,116,0.4)] transition-all mb-6 text-center" data-id="element-172">
            Descargar Protocolo Ahora
          </motion.a>

          <div className="flex flex-col md:flex-row items-center justify-center gap-4 text-sm text-[#F5F0E8]/50" data-id="element-173">
            <div className="flex items-center gap-2" data-id="element-174">
              <Shield size={16} data-id="element-175" />
              <span data-id="element-176">Pago 100% seguro</span>
            </div>
            <div className="hidden md:block" data-id="element-177">•</div>
            <div data-id="element-178">Entrega inmediata por email</div>
          </div>

          <div className="mt-12 pt-8 border-t border-[#F5F0E8]/10" data-id="element-179">
            <p className="text-[#F5F0E8]/70 italic" data-id="element-180">
              "Lo que vale no es el PDF. Lo que vale es que a la noche no tengas
              que inventar nada: solo ejecutar."
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}